import { render, staticRenderFns } from "./SearchBarBase.vue?vue&type=template&id=6519a96e&scoped=true"
import script from "./SearchBarBase.vue?vue&type=script&lang=js"
export * from "./SearchBarBase.vue?vue&type=script&lang=js"
import style0 from "./SearchBarBase.vue?vue&type=style&index=0&id=6519a96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519a96e",
  null
  
)

export default component.exports